import { FieldProp } from "./model/FieldProp";
import React from "react";
import "./ExtendedProperty.scss";
import CheckBoxBooleanField from "./Fields/CheckBoxBooleanField";
import CurrencyField from "./Fields/CurrencyField";
import DateField from "./Fields/DateField";
import DateTimeField from "./Fields/DateTimeField";
import DecimalField from "./Fields/DecimalField";
import DropdownBooleanField from "./Fields/DropdownBooleanField";
import DurationField from "./Fields/DurationField";
import EmailField from "./Fields/EmailField";
import EnumField from "./Fields/EnumField";
import EnumMultiValueField from "./Fields/EnumMultiValueField";
import GuidField from "./Fields/GuidField";
import IntegerField from "./Fields/IntegerField";
import LongTextField from "./Fields/LongTextField";
import ReferenceField from "./Fields/ReferenceField";
import TextField from "./Fields/TextField";
import UrlField from "./Fields/UrlField";

export enum FormatType {
    Integer,
    IntegerPercent,
    Duration,
    DateTime,
    Date,
    Guid,
    Currency,
    Boolean,
    Text,
    LongText,
    EMail,
    Url,
    Decimal,
    Enum,
    EnumMultiValue,
    CheckboxBoolean,
    DropDownBoolean,
    ReferencedField,
    Reference,
}

interface ExtendedPropertyProps<TFieldValues> extends FieldProp<TFieldValues> {
    className: string;
}

export const limitString = (val: string, num: number = 40) => {
    if (val && val.length > num) {
        return val.substring(0, num) + "...";
    } else {
        return val;
    }
};

const ExtendedProperty = <TFieldValues extends any> (props: ExtendedPropertyProps<TFieldValues>) => {
    const renderField = (): React.ReactNode => {
        switch (FormatType[props.property.metaFieldType]) {
            case FormatType.Text:
                return <TextField {...props} />;
            case FormatType.Url:
                return <UrlField {...props} />;
            case FormatType.EMail:
                return <EmailField {...props} />;
            case FormatType.LongText:
                return <LongTextField {...props} />;
            case FormatType.Integer:
            case FormatType.IntegerPercent:
                return <IntegerField {...props} />;
            case FormatType.Duration:
                return <DurationField {...props} />;
            case FormatType.Guid:
                return <GuidField {...props} />;
            case FormatType.Currency:
                return <CurrencyField {...props} />;
            case FormatType.Decimal:
                return <DecimalField {...props} />;
            //This is currently breaking server side rendering needs to be fixed when we will have enum extended property (currently we dont have any)
            /*   case FormatType.Enum:
                return <EnumField {...props} />;
            case FormatType.EnumMultiValue:
                return <EnumMultiValueField {...props} />; */
            case FormatType.CheckboxBoolean:
                return <CheckBoxBooleanField {...props} />;
            case FormatType.DropDownBoolean:
                return <DropdownBooleanField {...props} />;
            case FormatType.Date:
                return <DateField {...props} />;
            case FormatType.DateTime:
                return <DateTimeField {...props} />;
            case FormatType.Reference:
                return <ReferenceField {...props} />;
            default:
                return <></>;
        }
    };

    return <>{renderField()}</>;
};

export default ExtendedProperty;
